import { render } from "./B2bTableDocumentacionDocumentos.vue?vue&type=template&id=2e10f474&scoped=true&lang=pug"
import script from "./B2bTableDocumentacionDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bTableDocumentacionDocumentos.vue?vue&type=script&lang=js"

import "./B2bTableDocumentacionDocumentos.vue?vue&type=style&index=0&id=2e10f474&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e10f474"]])

export default __exports__